export class UserProfileModel {
    userGuid: string | undefined;
    userName: string| undefined;
    email: string| undefined;
    mobile: string| undefined;
    roleGuid: string| undefined;
    roleName: string| undefined;
    companyGuid: string| undefined;
    accessToken: string| undefined;
}